/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SourceAxisDistance } from './SourceAxisDistance';
import {
    instanceOfSourceAxisDistance,
    SourceAxisDistanceFromJSON,
    SourceAxisDistanceFromJSONTyped,
    SourceAxisDistanceToJSON,
} from './SourceAxisDistance';

/**
 * @type CreateLinearAcceleratorDtoSourceAxisDistance
 * 
 * @export
 */
export type CreateLinearAcceleratorDtoSourceAxisDistance = SourceAxisDistance;


export function CreateLinearAcceleratorDtoSourceAxisDistanceFromJSON(json: any): CreateLinearAcceleratorDtoSourceAxisDistance {
    return CreateLinearAcceleratorDtoSourceAxisDistanceFromJSONTyped(json, false);
}

export function CreateLinearAcceleratorDtoSourceAxisDistanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLinearAcceleratorDtoSourceAxisDistance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...SourceAxisDistanceFromJSONTyped(json, true) };
    return  SourceAxisDistanceFromJSONTyped(json, true);
}

export function CreateLinearAcceleratorDtoSourceAxisDistanceToJSON(value?: CreateLinearAcceleratorDtoSourceAxisDistance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfSourceAxisDistance(value)) {
        return SourceAxisDistanceToJSON(value as SourceAxisDistance);
    }

    return {};
}

/**
 * Check if a given object implements the CreateLinearAcceleratorDtoSourceAxisDistance interface.
 */
export function instanceOfCreateLinearAcceleratorDtoSourceAxisDistance(value: any): value is CreateLinearAcceleratorDtoSourceAxisDistance {
    if (instanceOfSourceAxisDistance(value)) return true;
    return false;
}

